const Fonts = {
    "Exo 2": {
        familyBase: "sans-serif",
        url: "/fonts/Exo2/Exo2.css",
    },
    Merriweather: {
        familyBase: "serif",
        url: "/fonts/Merriweather/Merriweather.css",
    },
    Montserrat: {
        familyBase: "sans-serif",
        url: "/fonts/Montserrat/Montserrat.css",
    },
    "Open Sans": {
        familyBase: "sans-serif",
        url: "/fonts/OpenSans/OpenSans.css",
    },
    Philosopher: {
        familyBase: "sans-serif",
        url: "/fonts/Philosopher/Philosopher.css",
    },
    Play: {
        familyBase: "sans-serif",
        url: "/fonts/Play/Play.css",
    },
    Roboto: {
        familyBase: "sans-serif",
        url: "/fonts/Roboto/Roboto.css",
    },
    Ubuntu: {
        familyBase: "sans-serif",
        url: "/fonts/Ubuntu/Ubuntu.css",
    },
};

export { Fonts };
